module.exports = __webpack_public_path__ + "img/spinner-indic.b14eb02c.png";